export default __webpack_public_path__ + "static/media/smaller-blue-hill-header.c5df8d7e.svg";